export default __webpack_public_path__ + "static/media/logo_home.9590d7ed.svg";